import { FormAPI } from 'lecom-api';

export default class GridFormStoreItem {
	_name;
	_waitingForAction;
	_fields;
	_columns;
	_actions;
	_formAction;
	_selectedRowId;
	_selectedDataRow;
	_gridPage;
	_gridPerPage;
	_formId;
	_loadFirstPage;
	_clientSideIdField;
	_loadedPages;
	_dataStoreRoute;
	_dataRows;
	_dataRowIdField;
	_totalCount;
	_totalCountLoaded;
	_commands;
	_initialValues;
	_errors;
	_disabled;
	_hidden;
	_visible;
	_readOnly;
	_initialVisible;
	_className;
	_component;
	_validations;
	_type;
	_fieldGroupingId;
	_propsRows

	constructor({
		name,
		formId,
		fields = [],
		columns,
		actions,
		loadFirstPage = true,
		clientSideIdField,
		gridDataStoreRoute,
		dataRows = [],
		dataRowIdField = 'id',
		errors,
		disabled,
		hidden,
		visible,
		readOnly,
		initialVisible,
		className,
		component,
		validations,
		type,
		fieldGroupingId,
		propsRows
	} = {}) {
		this.name = name;
		this.waitingForAction = false;
		this.fields = fields;
		this.actions = actions;
		this.formAction = 'create';
		this.gridPage = 1;
		this.gridPerPage = null;
		this.formId = formId;
		this.loadFirstPage = loadFirstPage;
		this.clientSideIdField = clientSideIdField;
		this.loadedPages = [];
		this.dataStoreRoute = gridDataStoreRoute;
		this.dataRows = dataRows;
		this.dataRowIdField = dataRowIdField;
		this.totalCount = dataRows.length;
		this.totalCountLoaded = false;
		this.commands = [];
		this.initialValues = null;
		this._columns = columns;
		this._errors = errors;
		this._disabled = disabled;
		this._hidden = hidden;
		this._visible = visible;
		this._readOnly = readOnly;
		this._initialVisible = initialVisible;
		this._className = className;
		this._component = component;
		this._validations = validations;
		this._type = type;
		this._fieldGroupingId = fieldGroupingId;
		this._propsRows = propsRows || {};
	}

	get name() {
		return this._name;
	}

	set name(value) {
		this._name = value;
	}

	get waitingForAction() {
		return this._waitingForAction;
	}

	set waitingForAction(value) {
		this._waitingForAction = value;
	}

	get fields() {
		return this._fields;
	}

	set fields(value) {
		this._fields = value;
	}

	get columns() {
		return this._columns;
	}

	set columns(value) {
		this._columns = value;
	}

	get actions() {
		return this._actions;
	}

	set actions(value) {
		this._actions = value;
	}

	get formAction() {
		return this._formAction;
	}

	set formAction(value) {
		this._formAction = value;
	}

	get selectedRowId() {
		return this._selectedRowId;
	}

	set selectedRowId(value) {
		this._selectedRowId = value;
	}

	get selectedDataRow() {
		return this._selectedDataRow;
	}

	set selectedDataRow(value) {
		this._selectedDataRow = value;
	}

	get gridPage() {
		return this._gridPage;
	}

	set gridPage(value) {
		this._gridPage = value;
	}

	get gridPerPage() {
		return this._gridPerPage;
	}

	set gridPerPage(value) {
		this._gridPerPage = value;
	}

	get formId() {
		return this._formId;
	}

	set formId(value) {
		this._formId = value;
	}

	get loadFirstPage() {
		return this._loadFirstPage;
	}

	set loadFirstPage(value) {
		this._loadFirstPage = value;
	}

	get clientSideIdField() {
		return this._clientSideIdField;
	}

	set clientSideIdField(value) {
		this._clientSideIdField = value;
	}

	get loadedPages() {
		return this._loadedPages;
	}

	set loadedPages(value) {
		this._loadedPages = value;
	}

	get dataStoreRoute() {
		return this._dataStoreRoute;
	}

	set dataStoreRoute(value) {
		this._dataStoreRoute = value;
	}

	get dataRows() {
		return this._dataRows;
	}

	set dataRows(value) {
		this._dataRows = value;
	}

	get dataRowIdField() {
		return this._dataRowIdField;
	}

	set dataRowIdField(value) {
		this._dataRowIdField = value;
	}

	get totalCount() {
		return this._totalCount;
	}

	set totalCount(value) {
		this._totalCount = value;
	}

	get totalCountLoaded() {
		return this._totalCountLoaded;
	}

	set totalCountLoaded(value) {
		this._totalCountLoaded = value;
	}

	get commands() {
		return this._commands;
	}

	set commands(value) {
		this._commands = value;
	}

	get initialValues() {
		return this._initialValues;
	}

	set initialValues(value) {
		this._initialValues = value;
	}

	get errors() {
		return this._errors;
	}

	set errors(value) {
		this._errors = value;
	}

	get disabled() {
		return this._disabled;
	}

	set disabled(value) {
		this._disabled = value;
	}

	get hidden() {
		return this._hidden;
	}

	set hidden(value) {
		this._hidden = value;
	}

	get visible() {
		return this._visible;
	}

	set visible(value) {
		this._visible = value;
	}

	get readOnly() {
		return this._readOnly;
	}

	set readOnly(value) {
		this._readOnly = value;
	}

	get initialVisible() {
		return this._initialVisible;
	}

	set initialVisible(value) {
		this._initialVisible = value;
	}

	get className() {
		return this._className;
	}

	set className(value) {
		this._className = value;
	}

	get component() {
		return this._component;
	}

	set component(value) {
		this._component = value;
	}

	get validations() {
		return this._validations;
	}

	set validations(value) {
		this._validations = value;
	}

	get type() {
		return this._type;
	}

	set type(value) {
		this._type = value;
	}

	get fieldGroupingId() {
		return this._fieldGroupingId;
	}

	set fieldGroupingId(value) {
		this._fieldGroupingId = value;
	}

	get propsRows() {
		return this._propsRows;
	}

	set propsRows(value) {
		this._propsRows = value;
	}
}

